/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_TravelInputs */

const en_category_travel = /** @type {(inputs: Category_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travel`)
};

const zh_hans1_category_travel = /** @type {(inputs: Category_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旅行`)
};

const pt_br2_category_travel = /** @type {(inputs: Category_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viagens`)
};

const es_category_travel = /** @type {(inputs: Category_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viajes`)
};

const fr_category_travel = /** @type {(inputs: Category_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voyage`)
};

const de_category_travel = /** @type {(inputs: Category_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reisen`)
};

const ru_category_travel = /** @type {(inputs: Category_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Путешествия`)
};

const it_category_travel = /** @type {(inputs: Category_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viaggi`)
};

/**
* | output |
* | --- |
* | "Travel" |
*
* @param {Category_TravelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const category_travel = /** @type {((inputs?: Category_TravelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_TravelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_category_travel(inputs)
	if (locale === "pt-BR") return pt_br2_category_travel(inputs)
	if (locale === "es") return es_category_travel(inputs)
	if (locale === "fr") return fr_category_travel(inputs)
	if (locale === "de") return de_category_travel(inputs)
	if (locale === "ru") return ru_category_travel(inputs)
	if (locale === "it") return it_category_travel(inputs)
	return en_category_travel(inputs)
});